export const url_apicentre_apiconnections = 'apicentre/apiconnections'
export const url_apicentre_apiconnections_id_logs = 'apicentre/apiconnections/:APIId/logs'
export const url_apicentre_apiconnections_logs = 'apicentre/apiconnections/logs'
export const url_featuretoggles = 'featuretoggles'
export const url_files_dropdown = 'files/dropdown'
export const url_files_id = 'files/:fileId'
export const url_files_manuals_documents = 'files/manuals/documents'
export const url_languages_dropdown = 'languages/dropdown'
export const url_manuals_documents_versions_files_id_download =
	'manuals/documents/versions/files/:fileId/download'
export const url_modules_enabled = 'modules/enabled'
export const url_modules_modules = 'modules/modules'
export const url_notificationcenter_notifications = 'notificationcenter/notifications'
export const url_notifications_types = 'notifications/types'
export const url_notifications_types_id = 'notifications/types/:id'
export const url_notifications_types_recipients = 'notifications/types/recipients'
export const url_notifications_types_requirements = 'notifications/types/requirements'
export const url_notifications_types_triggers = 'notifications/types/triggers'
export const url_organization_divisiontree = 'organization/divisiontree'
export const url_organization_divisiontree_verifiers =
	'organization/divisiontree/show_action_verifier'
export const url_organization_divisiontree_executors =
	'organization/divisiontree/show_action_executor'
export const url_organization_divisiontree_createuser = 'organization/divisiontree/create_user'
export const url_systemlanguages = 'systemlanguages'
export const url_systemlanguages_dropdown = 'systemlanguages/dropdown'
export const url_templates = 'templates'
export const url_templates_id_download = 'templates/:id/download'
export const url_templates_id_id = 'templates/:identifier/:id'
export const url_tiles = 'tiles'
export const url_user_preferences = 'user/preferences'
export const url_users = 'users'
export const url_users_export = 'users/export'
